export default {
  sections: [],
};
